import React, { useState } from 'react';

function Newsletter() {
    const [email, setEmail] = useState('');
    const [subscribed, setSubscribed] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch('https://dgm-backend.vercel.app/api/subscribe', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json(); // Parse JSON response

            if (response.ok) {
                setSubscribed(true);
                setError(''); // Clear any previous errors
            } else {
                setError(data.error || 'Failed to subscribe. Please try again.'); // Display backend error message
            }
        } catch (error) {
            setError('Failed to subscribe. Please try again.'); // Handle fetch errors
        }
    };

    return (
        <div className="container-xxl bg-primary newsletter py-5 wow fadeInUp" data-wow-delay="0.1s">
            <div className="container py-5 px-lg-5">
                <div className="row justify-content-center">
                    <div className="col-lg-7 text-center">
                        <p className="section-title text-white justify-content-center"><span />Newsletter<span /></p>
                        <h1 className="text-center text-white mb-4">Stay Always In Touch</h1>
                        <p className="text-white mb-4">
                            Stay ahead with DGM&apos;s newsletter for the latest tech trends and expert insights, delivered to your inbox.
                        </p>
                        {subscribed ? (
                            <p className="text-success">Thank you for subscribing!</p>
                        ) : (
                            <form onSubmit={handleSubmit}>
                                <div className="position-relative w-100 my-3" >
                                    <input
                                        className="form-control border-0 rounded-pill w-100 ps-4 pe-5"
                                        type="email"
                                        placeholder="Enter Your Email"
                                        style={{ height: 48 }}
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required
                                    />
                                    <button type="submit" className="btn shadow-none position-absolute top-0 end-0 mt-1 me-2">
                                        <i className="fa fa-paper-plane text-primary fs-4" />
                                    </button>
                                </div>
                                {error && <p className="text-white">{error}</p>}
                            </form>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Newsletter;
